<template>
	<div class="xmly-masker">
	    <div class="xmly-pop">
	        <div class="title-panel">
	            <div class="pic">
	                <img src="http://fdfs.xmcdn.com/group31/M03/1E/C4/wKgJSVmBaJ-CjgQUAAOU3Y8Z6M8121_mobile_medium.jpg" alt="">
	            </div>
	            <div class="info"><span class="name elli">{{nickName}}</span> 您好！</div>
	        </div>
	        <h2 class="choose-tit">{{role ? '请选择您需要的账号角色':'您的账号没有角色'}}</h2>
	        <ul class="xmly-account-list">
	            <li class="xmly-account-item" @click="chooseRole(account.id)" v-for="account in accounts" :key="account.id">
	                <a>
	                   <div class="arrow"></div>
	                    <div class="content">
	                        <div class="xmly-account-info elli"><label>区域：</label>{{account.provinceName+account.cityName+account.areaNames}}</div>
	                        <div class="xmly-account-info elli"><label>身份：</label>{{account.promotorType ==1 ? '城市合伙人':'分销商'}}</div>
	                        <div class="xmly-account-info elli"><label>登录时间：</label>{{format(account.lastLoginAt)+' 登录过'}}</div> 
	                    </div>                                                   
	                </a>
	            </li>
	        </ul>
	        <el-button class="xmly-account-logout" type="default" @click="logout">切换账号</el-button>
	    </div>
	</div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
import {chooseAccount} from 'api'
export default{
	data(){
		return {
			accounts:[],
			nickName: this.name,
			role:1
		}
	},
	computed: {
	  ...mapGetters([
	    'name'
	  ])
	},
	created(){
		let vis = this
		chooseAccount().then(res=>{
			if(res.data.length===1){
				vis.chooseRole(res.data[0].id)
			}
			vis.accounts  =res.data
		}).catch(error => {
			vis.role = 0
    	})
	},
	methods:{
		format(time){
			const t = new Date(time);
			const y = t.getFullYear();
			const m = t.getMonth()+1;
			const d = t.getDate();
			return y.toString().substr(2)+'-'+m+'-'+d
		},
		chooseRole(id){
			let vis = this
			/*chooseAccount(id).then(res=>{
				vis.$router.push({name:'Operate'})
			})*/
			this.$store.dispatch('Choose', id).then(res=>{
				if(res.ret==0){
					this.$router.push({name:'Operate'});
				}
			})
		},
		logout() {
	    	this.$store.dispatch('LogOut').then(() => {
	    		location.reload();// 为了重新实例化vue-router对象 避免bug
	    	})
	    }
	}
}
</script>

<style lang="scss" scoped>
	.elli{
	    white-space: nowrap;
	    overflow: hidden;
	    text-overflow: ellipsis;
	}
	.xmly-pop{
	    position: fixed;
	    left:0;
	    right:0;
	    top:50%;
	    transform:translateY(-50%);
	    -webkit-transform:translateY(-50%);
	    margin:auto;
	    width:510px;
	    height: -webkit-fill-available;
		height: -moz-fill-available;
		height: -moz-available;    /* FireFox目前这个生效 */
		height: fill-available;
	    background: #FFFFFF;
	    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.12);
	    padding:44px 68px 30px;
	    overflow: scroll;
	}
	.xmly-pop .title-panel{
	    text-align: center;
	    font-size: 0;
	}
	.xmly-pop .title-panel .info{
	    display: inline-block;
	    font-size: 16px;
	    color:#000;
	    vertical-align: middle;
	}
	.xmly-pop .title-panel .info .name{ 
	    display: inline-block;
	    max-width:265px;
	    vertical-align: bottom;
	}
	.xmly-pop .title-panel .pic{
	    width:45px;
	    height: 45px;
	    display: inline-block;
	    border-radius: 50%;  
	    vertical-align: middle;  
	    margin-right: 10px;    
	}
	.xmly-pop .title-panel .pic img{
	    width:100%;
	    height:100%;
	    border-radius: 50%;
	}    
	.xmly-pop .choose-tit{
	    text-align: center;
	    font-size: 16px;
	    color:#000;
	    margin: 25px 0 5px;
	    font-weight: normal;
	}
	.xmly-account-list{
	    border-radius: 4px;
	    font-size:12px;
	    color:#333;
	}
	.xmly-account-list .xmly-account-item{
	    margin-top:10px;
	    background: #fff0ec;
	    border-radius: 4px;
	}
	.xmly-account-list .xmly-account-item a{
	    display: block;
	    padding:10px 15px;
	}
	.xmly-account-list .xmly-account-item .content{
	    padding-right:30px;
	}
	.xmly-account-list .xmly-account-item .xmly-account-info{
	    line-height: 28px;
	}
	.xmly-account-list .xmly-account-item .xmly-account-info label{
	    color:#999;
	    display:inline-block;
	    width:60px;
	    margin-right: 5px;
	    text-align: right;
	}
	.xmly-account-logout {
		margin-left: 137px;
		margin-top: 10px;
	}
	.arrow{
	    float: right;
	    width:10px;
	    height:10px;
	    border-right:1px solid #999;
	    border-top:1px solid #999;
	    margin-top: 40px;
	    transform: rotate(45deg);
	    -webkit-transform: rotate(45deg);
	}
</style>




// WEBPACK FOOTER //
// index.vue?5352f0ac